import React from 'react';
import cls from 'classnames';
import '../Styles/hero.css';
import { NavLink } from 'react-router-dom';

const Hero = () => {
  return (
    <section
      className={cls(
        `h-screen w-full flex items-center relative overflow-hidden hero`
      )}
      style={{ paddingTop: 150 }}
    >
      <div className='container md:-mt-40'>
        <article className='flex flex-col'>
          <h1 className='text-4xl sm:text-6xl lg:text-7xl leading-none font-extrabold tracking-tight text-white mb-3 sm:mb-8'>
            I'm a Full stack web developer
          </h1>
          <h3
            style={{ color: '#C066D8' }}
            className='order-first sm:text-lg sm:leading-snug font-semibold tracking-wide uppercase mb-3'
          >
            <NavLink to='/about'>HELLO, MY NAME IS UMAD AHMAD</NavLink>
          </h3>
          <p className='max-w-screen-lg text-lg sm:text-2xl sm:leading-10 font-medium mb-12 sm:mb-14 text-white'>
            I'm a freelancer as MERN Web Developer. I love to develop
            outstanding websites and webapps with beautiful and smooth user
            interfaces with a fast and scalable backend. I have a small team of
            MERN Developers. If you need any project outsourcing form us, feel
            free to{' '}
            <a href='contact' style={{ color: '#C066D8' }}>
              contact us
            </a>
            .
          </p>
        </article>

        <NavLink
          className='flex-none bg-gray-900 hover:bg-gray-700 text-white text-lg leading-6 font-semibold py-3 px-6 border border-transparent rounded-xl ring-2 ring-offset-2 ring-offset-white ring-gray-900 focus:outline-none transition-colors duration-200'
          to='/contact'
        >
          <span className='lg:hidden'>Contact me</span>
          <span className='hidden lg:inline'>Let's work together</span>
        </NavLink>
      </div>
    </section>
  );
};

export default Hero;
